export const environment = {
  apiUrl: 'https://admin.dev.restopilot360.fr/api',
  appUrl :'https://dev.restopilot360.fr/',

}
